import React, { useEffect, useState } from 'react';
import { useHistory, useParams } from 'react-router-dom';
import axios from 'axios';
import User from './User';
import '../index.css';

const EditForm = () => {
    let {id} = useParams();

    const [loadingData, setLoadingData] = useState(true);

    const [inputs, setInputs] = useState({});
    const [image,setImage] = useState();
   
    useEffect(() => {
        async function getData(){
             axios.get(`https://innounita.univ-unita.eu/backend/companies/${id}`)
            .then((response) => {
                setInputs(response.data)
                
            });
            while (User.isLoading){
                await new Promise(resolve => setTimeout(resolve, 2));
            }
            setLoadingData(false)
        }
        if (loadingData) {
             getData();
        }
    },[]);



    const [images, setImages] = useState([])
    // const [imageURLs, setImageURLs] = useState([])
    // const [name, setName] = useState('')
    // const [university, setUniversity] = useState('')
    // const [website, setWebsite] = useState('')
    // const [year, setYear] = useState('')
    const history = useHistory();


    // useEffect (() => {
    //     if (images.length < 1) return;
    //     const newImageURLs = [];
    //     images.forEach(image => newImageURLs.push());
    //     setImageURLs(newImageURLs); 
    // }, [images]);


    function onImageChange(e) {
        setImage(e.target.files[0]);
        const name = e.target.name;
        const value =  URL.createObjectURL(e.target.files[0]);
        setInputs(values => ({...values, [name]: value}))
        // setImages([...e.target.files]);
    }


    const handleChange = (e) => {
        const name = e.target.name;
        const value = e.target.value;
        setInputs(values => ({...values, [name]: value}))
    }

    

    const handleSubmit = (e) => {
        e.preventDefault();
        // const edit = {  data }
        inputs.logo="";
        const formData = new FormData();
        if (image != null){
            formData.append("file",image);
        }
        formData.append("company", JSON.stringify(inputs));
        axios.post("https://innounita.univ-unita.eu/backend/companies/update",formData,{
            headers: {'content-type':'multipart/form-data'}
        }) .then(()=>{
            history.go(-1);
            alert("Edited successfully!")
        })
        .catch(function (error) {
            console.log(error);
            alert('Something went wrong!')
        });
        //  history.push('/companies');
    }
    var isAdmin = false;
    for(var grantedAuthority of User.authorities){
        if (grantedAuthority.authority === "ROLE_ADMIN" || grantedAuthority.authority === "ROLE_UNIVERSITY" || inputs.email === User.data.username){
            isAdmin = true;
            break;
        }
    }

        if(isAdmin){
            return (
                <div className="login-body">
                    <div className="ui container">
                        <div className="login-background">
                            <div className="ui left aligned container login-field">
                                <form className="ui form" onSubmit={handleSubmit}>
                                    <div style={{ "textAlign" : "center" }}><img className="" src={inputs.logo}  height='50px'/><br/></div>
                                    <label>Logo</label>
                                    <input type="file" name='logo' accept="image/*" onChange={onImageChange}/>
                                
                                    <label>Name</label>
                                    <input type="text" name='name' value={inputs.name|| ""}  onChange={handleChange} />
                                    <label>Contact Person</label>
                                    <input type="text" name='contactPersonName' value={inputs.contactPersonName|| ""}  onChange={handleChange} />
                                    <label>Contact Person Role</label>
                                    <input type="text" name='contactPersonRole' value={inputs.contactPersonRole|| ""}  onChange={handleChange} />
                                    <label>Email</label>
                                    <input type="text" name='email' value={inputs.email|| ""}  onChange={handleChange} />
                                    <label>University</label>
                                    <input type="text" name='university'  value={inputs.university || ""} onChange={handleChange} />
                                    <label>Website</label>
                                    <input type="text" name='website'  value={inputs.website || ""} onChange={handleChange} />
                                    <label>Location</label>
                                    <input type="text" name='geoLocationCoordinates'  value={inputs.geoLocationCoordinates || ""} onChange={handleChange} />
                                    <label>Countries</label>
                                    <input type="text" name='countries'  value={inputs.countries || ""} onChange={handleChange} />
                                    <label>NACE</label>
                                    <input type="text" name='mainNACE'  value={inputs.mainNACE || ""} onChange={handleChange} />
                                    <label>Company Activity</label>
                                    <input type="text" name='companyActivity'  value={inputs.companyActivity || ""} onChange={handleChange} />
                                    <label>Business Model</label>
                                    <input type="text" name='bussinessModel'  value={inputs.bussinessModel || ""} onChange={handleChange} />
                                    <label>Employee Count</label>
                                    <input type="text" name='employeeCount'  value={inputs.employeeCount || ""} onChange={handleChange} />
                                    <label>Year Founded</label>
                                    <input type="text" name='yearFounded'  value={inputs.yearFounded || ""} onChange={handleChange} />
                                    <label>Initial Country</label>
                                    <input type="text" name='initialCountry'  value={inputs.initialCountry || ""} onChange={handleChange} />
                                    <label>Turnover</label>
                                    <input type="text" name='turnoverN'  value={inputs.turnoverN || ""} onChange={handleChange} />
                                    <label>TurnoverN1</label>
                                    <input type="text" name='turnoverN1'  value={inputs.turnoverN1 || ""} onChange={handleChange} />
                                    <label>TurnoverN2</label>
                                    <input type="text" name='turnoverN2'  value={inputs.turnoverN2 || ""} onChange={handleChange} />
                                    <label>TurnoverN3</label>
                                    <input type="text" name='turnoverN3'  value={inputs.turnoverN3 || ""} onChange={handleChange} />
                                    <label>TurnoverN4</label>
                                    <input type="text" name='turnoverN4'  value={inputs.turnoverN4 || ""} onChange={handleChange} />
                                    <label>Revenue</label>
                                    <input type="text" name='preRevenue'  value={inputs.preRevenue || ""} onChange={handleChange} />
                                    <label>Entreprenourship</label>
                                    <input type="text" name='entreprenourship'  value={inputs.entreprenourship || ""} onChange={handleChange} />
                                    <label>Innovation</label>
                                    <input type="text" name='innovationEducation'  value={inputs.innovationEducation || ""} onChange={handleChange} />
                                    <label>Mentorship</label>
                                    <input type="text" name='mentorship'  value={inputs.mentorship || ""} onChange={handleChange} />
                                    <label>Incubation Services</label>
                                    <input type="text" name='incubationServices'  value={inputs.incubationServices || ""} onChange={handleChange} />
                                    <label>Acceleration Services</label>
                                    <input type="text" name='accelerationServices'  value={inputs.accelerationServices || ""} onChange={handleChange} />
                                    <label>Funding Provided</label>
                                    <input type="text" name='fundingProvided'  value={inputs.fundingProvided || ""} onChange={handleChange} />
                                    <label>Collaborative RDP</label>
                                    <input type="text" name='collaborativeRDP'  value={inputs.collaborativeRDP || ""} onChange={handleChange} />
                                    <label>Patent</label>
                                    <input type="text" name='patent'  value={inputs.patent || ""} onChange={handleChange} />
                                    <label>Internship</label>
                                    <input type="text" name='internship'  value={inputs.internship || ""} onChange={handleChange} />
                                    <label>Spinoff</label>
                                    <input type="text" name='spinoff'  value={inputs.spinoff || ""} onChange={handleChange} />
                                    <label>Founders Are Alumni</label>
                                    <input type="text" name='foundersAreAlumni'  value={inputs.foundersAreAlumni || ""} onChange={handleChange} />
                                    <label>Percentage Employee Alumni</label>
                                    <input type="text" name='percentageEmployeeAlumni'  value={inputs.percentageEmployeeAlumni || ""} onChange={handleChange} />
                                    <label>Percentage Employee Tertiary Ed</label>
                                    <input type="text" name='percentageEmployeeTertiaryEd'  value={inputs.percentageEmployeeTertiaryEd || ""} onChange={handleChange} />
                                    <label>Percentage Employee PHD</label>
                                    <input type="text" name='percentageEmployeePHD'  value={inputs.percentageEmployeePHD || ""} onChange={handleChange} />
                                    <label>Num Scientific Copublications</label>
                                    <input type="text" name='numScientificCopublications'  value={inputs.numScientificCopublications || ""} onChange={handleChange} />
                                    <label>percentage RD Expediture</label>
                                    <input type="text" name='percentageRDExpediture'  value={inputs.percentageRDExpediture || ""} onChange={handleChange} />
                                    <label>Has Innovations</label>
                                    <input type="text" name='hasInnovations'  value={inputs.hasInnovations || ""} onChange={handleChange} />
                                    <label>Has Intelectual Assets</label>
                                    <input type="text" name='hasIntelectualAssets'  value={inputs.hasIntelectualAssets || ""} onChange={handleChange} />
                                    <label>Aligned UNSDG</label>
                                    <input type="text" name='alignedUNSDG'  value={inputs.alignedUNSDG || ""} onChange={handleChange} />
                                    <label>Generating Periodical Report</label>
                                    <input type="text" name='generatingPeriodicalReport'  value={inputs.generatingPeriodicalReport || ""} onChange={handleChange} />
                                    <label>Has Raised Investment Round</label>
                                    <input type="text" name='hasRaisedInvestmentRound'  value={inputs.hasRaisedInvestmentRound || ""} onChange={handleChange} />
                                    <label>Has Raised Nondillutive Founding</label>
                                    <input type="text" name='hasRaisedNonDillutiveFounding'  value={inputs.hasRaisedNonDillutiveFounding || ""} onChange={handleChange} />
                                    <label>Entrepreneurial Booster Scheme</label>
                                    <input type="text" name='entrepreneurialBoosterScheme'  value={inputs.entrepreneurialBoosterScheme || ""} onChange={handleChange} />
                                    <label>CEO is Woman</label>
                                    <input type="text" name='isCEOWoman'  value={inputs.isCEOWoman || ""} onChange={handleChange} />
                                    <br/><br/>
                                    <div className="login-button">
                                        <button className="ui button primary">Save</button>
                                    </div>
                                </form>
                            </div>
                        </div>
                    </div>
                </div>
                );
        }else{
            
        }
}


export default EditForm;